import styled from "styled-components";

export const RequestApprovalContainer = styled.div`
  width: 100%;
  height: 900px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;
export const RequestApprovalContainerContent = styled.div`
  width: 100%;
  min-height: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #c1c1c1;
`;
export const RequestApprovalContainerContentResume = styled.div`
  width: 190px;
  height: 50px;
  display: flex;
  align-items: center;
`;
export const RequestApprovalContainerContentResumeContent = styled.div`
  width: 80%;
  height: 50%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  p {
    font-size: 20px;
    font-family: "Akrobat";
    color: #58595b;

    strong {
      font-family: "Akrobat ExtraBold";
      color: #ff7e00;
    }
  }
`;
export const RequestApprovalContainerContentCard = styled.div`
  width: 97%;
  min-height: 420px;
  position: relative;
  margin-top: 25px;
  background-color: white;
  border-radius: 5px;

  &:nth-last-child(1) {
    margin-bottom: 20px;
  }
`;
export const RequestApprovalContainerContentCardTab = styled.div`
  width: 100%;
  height: 36px;
  margin-top: 15px;
  position: relative;
`;
export const RequestApprovalContainerContentCardTabContent = styled.div`
  width: 98%;
  height: 100%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  display: flex;
  justify-content: space-between;
`;
export const RequestApprovalContainerContentCardTabContentTitle = styled.div`
  width: 48%;
  height: 100%;
  position: relative;
  background-color: #80bd01;
  display: flex;
  align-items: center;
  justify-content: space-between;
  p {
    font-size: 17px;
    font-family: "Akrobat";
    color: white;
    display: flex;
    flex-direction: row;
    margin-left: 15px;
    padding-top: 8px;
    h1 {
      width: 30px;
      height: 30px;
      border-radius: 15px;
      font-size: 24px;
      position: relative;
      top: -4px;
      font-family: "Akrobat ExtraBold";
      padding-left: 12px;
      color: #80bd01;
      background-color: white;
      margin-left: 8px;
      margin-right: 8px;
    }
  }

  span {
    cursor: pointer;
    margin-right: 15px;
  }
`;
export const RequestApprovalContainerContentCardRequestApproval = styled.div`
  width: 100%;
  height: 75px;
  position: relative;
  display: flex;
  align-items: center;
  `;
export const RequestApprovalContainerContentCardRequestApprovalContent = styled.div`
  width: 97%;
  height: 90%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  display: flex;
  justify-content: space-between;
`;
export const RequestApprovalContainerContentCardRequestApprovalContentColumn = styled.div`
  width: 48%;
  height: 100%;
  position: relative;
`;
export const RequestApprovalContainerContentCardRequestApprovalContentColumnRow = styled.div`
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  p {
    font-size: 15px;
    font-family: "Akrobat";
    color: #58595b;

    &:nth-child(2) {
      font-size: 17px;
      font-family: "Akrobat SemiBold";
    }
  }
`;
export const RequestApprovalContainerContentCardProducts = styled.div`
  width: 100%;
  height: 65px;
  position: relative;
  display: flex;
  align-items: center;
`;
export const RequestApprovalContainerContentCardProductsContent = styled.div`
  width: 97%;
  height: 90%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  display: flex;
  justify-content: space-between;
`;
export const RequestApprovalContainerContentCardProductsContentColumn = styled.div`
  width: 48%;
  height: 90%;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  p {
    font-size: 17px;
    font-family: "Akrobat";
    color: #58595b;
    strong {
      font-size: 17px;
      font-family: "Akrobat ExtraBold";
      color: #80bd01;
    }
  }
`;
export const RequestApprovalContainerContentCardProductsContentColumnImage = styled.div`
  width: 40px;
  // height: 85px;
  display: flex;
  align-items: center;
  margin-right: 2px;
  img {
    width: 40px;
    border: 0.6px solid rgba(61, 61, 61, 0.131);
    border-radius: 3px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
  }
`;
export const RequestApprovalContainerContentCardProductsContentColumnDesc = styled.div`
  width: 460px;
  height: 45px;
  display: flex;
  justify-content: flex-start;
  margin-left: 3px;
  h1 {
    font-size: 15px;
    font-family: "Akrobat ExtraBold";
    letter-spacing: 0.03rem;
    color: rgb(61,61,61);
    margin-left: 3px;
  }
  span {
    position: relative;
    margin-left: 10px;
  }
  p {
    font-size: 14px;
    font-family: "Akrobat";
    margin-left: 2px;
    letter-spacing: 0.03rem;
    color: rgb(61,61,61);
    text-decoration: underline;
    cursor: pointer;
  }
`;
export const RequestApprovalContainerContentCardConfigProducts = styled.div`
  width: 100%;
  height: 65px;
  position: relative;
  display: flex;
  align-items: center;
  `;
export const RequestApprovalContainerContentCardConfigProductsContent = styled.div`
  width: 100%;
  height: 90%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(61, 61, 61, 0.131);

  table {
    width: 94%;
    height: 100%;
    position: relative;
    margin-left: 67px;
    top: -10px;
    tbody {
      td {
        width: 40px;
        height: 50px;
        margin-left: 45px;
        padding-right: 15px;
        border-left: 1px solid rgba(61, 61, 61, 0.131);
        p {
          width: 100%;
          height: 20px;
          font-size: 15px;
          font-family: "Akrobat";
          color: #58595b;
          display: flex;
          justify-content: space-between;
          margin-left: 10px;
          strong {
            margin-left: 10px;
            margin-right: 5px;
            &:nth-child(2) {
              color: #ff559a;
            }
          }
        }

        .pink {
          color: #ff559a;
        }

        &:nth-child(1) {
          width: 140px;
          border-left: none;
        }
        &:nth-child(2) {
          width: 168px;
        }
        &:nth-child(3) {
          width: 90px;
        }
        &:nth-child(4) {
          width: 190px;
        }
        &:nth-child(5) {
          width: 135px;
        }
        &:nth-child(6) {
          width: 100px;
        }
        &:nth-child(7) {
          border-right: none;
        }
      }
    }
  }
`;
export const RequestApprovalContainerContentCardShipping = styled.div`
  width: 100%;
  height: 115px;
  position: relative;
  display: flex;
  align-items: center;
  border-top: 1px solid rgba(61, 61, 61, 0.131);
`;
export const RequestApprovalContainerContentCardShippingContent = styled.div`
  width: 97%;
  height: 90%;
  position: relative;
  margin-right: auto;
  justify-content: space-between;
  background-color: white;
  display: flex;
  justify-content: flex-start;
`;
export const RequestApprovalContainerContentCardShippingContentColumn = styled.div`
  width: 47%;
  height: 100%;
  position: relative;
  margin-left: 2.8rem;
`;
export const RequestApprovalContainerContentCardShippingContentColumnRow = styled.div`
  width: 100%;
  height: 30px;

  p {
    font-size: 16px;
    font-family: "Akrobat";
    color: #58595b;

    strong {
      font-family: "Akrobat ExtraBold";
    }

    .orange {
      color: #ff7e00;
    }
  }
`;
export const RequestApprovalContainerContentCardResumoValue = styled.div`
  width: 100%;
  height: 40px;
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 5px;
  border-top: 1px solid rgba(61, 61, 61, 0.131);
`;
export const RequestApprovalContainerContentCardResumoValueContent = styled.div`
  width: 97%;
  height: 100%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  display: flex;
  justify-content: flex-start;
`;
export const RequestApprovalContainerContentCardResumoValueContentResume = styled.div`
  width: 80%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .line {
    width: 860px;
    height: 2px;
    background-color: rgba(61, 61, 61, 0.131);
  }

  h1 {
    width: 155px;
    font-size: 19px;
    font-family: "Akrobat";
    color: #58595b;

    strong {
      font-family: "Akrobat ExtraBold";
      color: #ff7e00;
    }
  }
`;
